import type { BaseImageStrapiType } from '@/strapi-types';
import { BaseImage } from './BaseImage';

// Inline `elements.image` blocks render inside the constrained article prose
// column (`.single-content img { width: 100% }`), not full-bleed. Without a
// `sizes` prop next/image would assume 100vw and download the largest
// candidate. This mirrors the value the article main image already uses so
// inline images pick a width-appropriate candidate instead. `sizes` is a
// code-only prop (never sent by Strapi), so this default always applies unless
// a code caller overrides it.
const INLINE_DEFAULT_SIZES =
  '(max-width: 640px) 100vw, (max-width: 1280px) 84vw, 1024px';

export function InlineImage(props: BaseImageStrapiType) {
  return <BaseImage {...props} sizes={props.sizes ?? INLINE_DEFAULT_SIZES} />;
}
